import { customReservedInventoryBucketTypeIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const deleteCustomReservedInventoryBucketType = {
  name: "deleteCustomReservedInventoryBucketType" as const,
  input: z.object({ id: customReservedInventoryBucketTypeIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
